import Constants from '../data/Constants';

const initialState = {
  activityWindow: Constants.GAME_VIEWS.LOADING,
  previousActivityWindow: '',
};

const activityReducer = (state = initialState, action) => {
  if (action.gameId !== Constants.GAME_ID) {
    return state;
  }

  switch (action.type) {
    case 'SET_ACTIVITY_WINDOW':
      return {
        ...state,
        activityWindow: action.payload.window,
        previousActivityWindow: state.activityWindow,
      };
    default:
      return state;
  }
};

export default activityReducer;
